module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Lista de contestações","deadline-expired-tooltip":"Apesar de você ter nos enviado a documentação, ela foi recusada e não existe mais tempo hábil para seguir com a contestação."},"en-US":{"title":"Disputes","deadline-expired-tooltip":"Although you sent us the documentation, it was rejected and there is no more time to pursue the dispute."}}')
  delete Component.options._Ctor
}
